import { NgModule } from '@angular/core';

import { LanguageSwitcherComponent } from '../components/language-switcher.component';
import { FormModule } from 'src/core/modules/form.Module';
import { LanguageSwitcherService } from '../services/language-switcher.service';

@NgModule({
  declarations: [
    LanguageSwitcherComponent
  ],
  imports:[
    FormModule

  ],
  exports:[
    LanguageSwitcherComponent
  ],
  providers:[
    LanguageSwitcherService
  ]
})
export class LanguageSwitcherModule { }
